module.exports = __webpack_public_path__ + "img/delete.405f6980.png";